module.exports = __webpack_public_path__ + "img/rejected_dark.d5ca9fba.svg";